/**
 * Componente copiado de ADF 5.0.0 y adaptado a nuestras necesidades
 */

import { SEARCH_QUERY_SERVICE_TOKEN, SearchFilterService } from '@alfresco/adf-content-services';
import {
    Component,
    Input,
    ViewChild,
    ViewContainerRef,
    OnInit,
    OnDestroy,
    ComponentRef,
    ComponentFactoryResolver,
    Inject
} from '@angular/core';
import { ColumnValue } from 'projects/alden-extension/src/lib/models/column-value';
import { CustomDataColumn } from 'projects/alden-extension/src/lib/models/custom-viewer-config';
import { Observable } from 'rxjs';

@Component({
    selector: 'smt-search-widget-container',
    template: '<div #content></div>'
})
export class SMTSearchWidgetContainerComponent implements OnInit, OnDestroy {

    @ViewChild('content', { read: ViewContainerRef, static: true })
    content: ViewContainerRef;

    @Input()
    filter: CustomDataColumn;
    
    componentRef: ComponentRef<any>;

    constructor(
        private searchFilterService: SearchFilterService,
        @Inject(SEARCH_QUERY_SERVICE_TOKEN) private queryBuilder,
        private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit() {
        const componentType = this.searchFilterService.widgets[this.filter?.search.selector];
        if (componentType) {
            const factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
            if (factory) {
                this.content.clear();
                this.componentRef = this.content.createComponent(factory, 0);
                this.setupWidget(this.componentRef);
            }
        }
    }

    private setupWidget(ref: ComponentRef<any>) {
        if (ref && ref.instance) {
            ref.instance.id = this.filter.id;
            ref.instance.settings = {...this.filter.search.settings};
            ref.instance.filter = {...this.filter};
            ref.instance.context = this.queryBuilder;
        }
    }

    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

    applyInnerWidget(): Promise<void> {
        return this.componentRef.instance.submitValues();
    }

    setValue(currentValue: string | any) {
        this.componentRef.instance.setValue(currentValue);
    }

    emitOnOpened() {
        // Si el componente escucha el opened
        if (typeof this.componentRef.instance.onWidgetOpened === 'function') {
            this.componentRef.instance.onWidgetOpened();
        }
    }

    emitOnClosed() {
        // Si el componente escucha el closed
        if (typeof this.componentRef.instance.onWidgetClosed === 'function') {
            this.componentRef.instance.onWidgetClosed();
        }
    }

    hasValidValue() {
        return this.componentRef.instance.hasValidValue();
    }

    getCurrentValue() {
        return this.componentRef.instance.getCurrentValue();
    }

    //Custom SMT
    getCurrentQuery() {
        return this.componentRef.instance.getCurrentQuery();
    }

    getDisplayValue(): Observable<ColumnValue> | null {
        if (!this.componentRef?.instance) {
            return null;
        }
        return this.componentRef.instance.displayValue$;
    }

    getDisplayError(): Observable<string> | null {
        if (!this.componentRef?.instance) {
            return null;
        }
        return this.componentRef.instance.displayError$;
    }

    resetInnerWidget() {
        if (this.componentRef && this.componentRef.instance) {
            this.componentRef.instance.reset();
        }
    }

    refreshFilterInnerWidget(){
        if (this.componentRef && this.componentRef.instance) {
            this.componentRef.instance.settings = {...this.filter.search.settings};
            this.componentRef.instance.refreshFilter();
        }
    }

    getAppliedValue(): any{
        const val = this.componentRef.instance.getAppliedValue();
        return val;
    }

    disable() {
        this.componentRef.instance.disable();
    }

    enable() {
        this.componentRef.instance.enable();
    }
}